export default {"src":"https://web.cdn.greenlight.com/2.1283.0/_next/static/media/close-icon.b6d56d21.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};